export default __webpack_public_path__ + "static/media/￼section2-img2-h5.1ec2abe4.png";